import React, {useCallback, useState} from 'react'
import CoverSelectorMenu from "./menu/menu"
import CoverSelectorMain from "./main/selector-main"
import AttachmentsCollection from "../../../model2/attachment/attachments"
import {Cover} from "../../../model2/task/properties/cover"
import {CoverType} from "../cover-type"

export const COVER_SELECTOR_MENU_HEIGHT   = 50

type Props = {
    menuParams: {
        initialType?      : CoverType
        cover?            : Cover
        attachments?      : AttachmentsCollection
        onCoverSelected   : {(cover?:Cover):void}
        enableAttachments : boolean
    }

    hidePopover : callback
}

const debug = false
// const debug = "CoverSelectorPopover"

export default function CoverSelectorPopover (props:Props) {

    const [coverType, setCoverType]   = useState(props.menuParams.initialType ? props.menuParams.initialType : CoverType.GALLERY)

    const onChangeMenu = useCallback((menuId:CoverType)=>{
        setCoverType(menuId)
    }, [])

    const onCoverSelected = useCallback((cover?:Cover)=>{
        debug && console.log(debug, 'onCoverSelected', cover)
        props.menuParams.onCoverSelected && props.menuParams.onCoverSelected(cover)
        props.hidePopover()
    }, [])

    const onRemove = () => {onCoverSelected()}

    debug && console.log(debug, 'render', coverType)

    const styles = {
        width   : 450,
        height  : coverType === CoverType.LINK ? 220 : 400
    }

    return (
        <div className="gd-cover-selector" style={styles}>
            <CoverSelectorMenu currentCoverType     = {coverType}
                               showRemove           = {!!props.menuParams.cover}
                               onSelect             = {onChangeMenu}
                               onRemove             = {onRemove}
                               enableAttachments    = {props.menuParams.enableAttachments}/>

            <CoverSelectorMain currentCoverType = {coverType}
                               attachments      = {props.menuParams.attachments}
                               onCoverSelected  = {onCoverSelected}/>
        </div>
    )
}
